import { type TSelectedAvailability } from 'webReservations/context/AvailabilityContext';

type MinimalAvailabilityInfoNeededToDeriveIntel = Pick<
  TSelectedAvailability,
  'isBestAvailable' | 'publicName'
>;

export const selectedAvailabilityDisplayName = ({
  isBestAvailable,
  publicName,
}: MinimalAvailabilityInfoNeededToDeriveIntel): null | string => {
  if (isBestAvailable || publicName === '') {
    return null;
  }

  return publicName;
};
